<template>
  <view-container
    class="view-tools-partners"
    header
    title="Central de colaboradores"
    subtitle="Libere permissões de acesso para seus colaboradores."
    :breadcrumbs="breadcrumbs"
  >
    <b-tabs content-class="mt-6" class="my-6">
      <b-tab title="Perfis de colaborador" active>
        <profiles />
      </b-tab>

      <b-tab title="Meus Colaboradores">
        <div class="toggle-wrapper">
          <b-form-radio
            v-model="collabsTab"
            button
            value="invites-sent"
            button-variant="outline-primary"
          >
            Convites enviados
          </b-form-radio>
          <b-form-radio
            v-model="collabsTab"
            button
            value="partners"
            button-variant="outline-primary"
          >
            Colaboradores
          </b-form-radio>
        </div>
        <invites-sent v-show="collabsTab === 'invites-sent'" />
        <partners v-show="collabsTab === 'partners'" />
      </b-tab>

      <b-tab title="Centrais que participo">
        <div class="toggle-wrapper">
          <b-form-radio
            v-model="centersTab"
            button
            value="invites-received"
            button-variant="outline-primary"
          >
            Convites recebidos
          </b-form-radio>
          <b-form-radio
            v-model="centersTab"
            button
            value="my-collabs"
            button-variant="outline-primary"
          >
            Centrais que participo
          </b-form-radio>
        </div>
        <invites-received v-show="centersTab === 'invites-received'" />
        <my-collabs v-show="centersTab === 'my-collabs'" />
      </b-tab>
    </b-tabs>
  </view-container>
</template>

<script>
import InvitesReceived from "@/components/tools/partners/InvitesReceived.vue";
import InvitesSent from "@/components/tools/partners/InvitesSent.vue";
import MyCollabs from "@/components/tools/partners/MyCollabs";
import Partners from "@/components/tools/partners/Partners";
import Profiles from "@/components/tools/partners/Profiles";

export default {
  components: {
    Profiles,
    Partners,
    MyCollabs,
    InvitesSent,
    InvitesReceived
  },
  data() {
    return {
      breadcrumbs: [
        { link: "tools", title: "Ferramentas" },
        { title: "Central de Colaboradores" }
      ],
      collabsTab: "invites-sent",
      centersTab: "invites-received"
    };
  }
};
</script>
<style lang="scss" scoped>
.view-tools-partners {
  .toggle-wrapper {
    display: flex;
    margin-bottom: 24px;
    gap: 16px;
  }
  ::v-deep {
    .nav-item {
      @media screen and (max-width: 991px) {
        flex: 1;
        text-align: center;
      }
      a {
        padding: 12px;
        &.active,
        &:hover {
          font-size: 14px;
        }
      }
    }
    .btn-group-toggle {
      .btn {
        padding: 0 16px;
        min-height: 32px;
        font-weight: 500;
        border-radius: 50px;
        &:not(.active, :hover) {
          color: #77788edd;
          border-color: #77788edd;
        }
      }
    }
  }
}
</style>
